import { Inbox } from "lucide-react";
import { NavigationItem } from "../../types";
import { BuilderContext } from "../context";

/**
 * Inbox — communication surfaces split out of the old "Customers" group:
 * the CRM inbox, calendar (and its connections), and public booking. Comms,
 * not pipeline.
 */
export function buildInboxSection(ctx: BuilderContext): NavigationItem | null {
  const { isCRM, isAdmin, isEmployee, isClientUser } = ctx;

  // Available to CRM users, employees, and admins
  if (!(isCRM || isAdmin || isEmployee)) return null;

  const inboxChildren: NavigationItem[] = [
    { id: "crm-inbox", name: "Inbox", href: "/crm/inbox" },
    {
      id: "crm-calendar",
      name: "Calendar",
      href: "/crm/calendar",
      children: [
        { id: "calendar-unified", name: "Unified View", href: "/crm/calendar/unified" },
        { id: "calendar-home", name: "Calendar Home", href: "/crm/calendar" },
        { id: "calendar-book", name: "Book Meeting", href: "/crm/calendar/book" },
        { id: "calendar-setup", name: "Setup", href: "/crm/calendar/setup" },
        {
          id: "calendar-public-booking",
          name: "Public Booking",
          href: "/crm/calendar/public-booking",
        },
      ],
    },
    // NOTE: Public Booking is intentionally listed ONLY as a Calendar child
    // (above). It used to ALSO appear as a sibling here, so the Inbox menu
    // showed the same destination twice.
    // Hide integrations for client users
    ...(!isClientUser
      ? [{ id: "crm-integrations", name: "Integrations", href: "/crm/integrations" }]
      : []),
  ];

  return {
    id: "inbox",
    name: "Inbox",
    href: "/crm/inbox",
    icon: Inbox,
    visible: true,
    order: 3,
    children: inboxChildren,
  };
}
